import { TGS_STICKERS } from '~/constants/tgs-stickers';

export const SadPenguin = TGS_STICKERS.CRYING;
